<!--
  AnimatedLoaderComponent — template
  ===================================
  Struttura a 3 wrapper annidati per simulare 3 animazioni CSS indipendenti
  (rotate / translateX / translateY) con durate diverse, replicando il
  comportamento di motion/react con transition separate per ogni asse.

  Animazioni SVG interne: SMIL puro (zero JS, zero dipendenze).
-->

<!-- WRAPPER 1 — rotazione: ±1deg, 2.1s -->
<div class="loader-wrap loader-rotate" [class.hidden]="hidden()">

    <!-- WRAPPER 2 — traslazione X: ±1px, 2.4s -->
    <div class="loader-wrap loader-translate-x">

        <!-- WRAPPER 3 — traslazione Y: ±1px, 2.8s -->
        <div class="loader-wrap loader-translate-y">

            <svg class="loader-svg" fill="none" preserveAspectRatio="xMidYMid meet" viewBox="0 0 394 497"
                xmlns="http://www.w3.org/2000/svg" aria-label="Loading..." role="img">
                <defs>
                    <!-- ── Filtro glow sfocatura ─────────────────────────────────── -->
                    <filter color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse" height="497"
                        id="filter0_f_5_55" width="394" x="0" y="0">
                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                        <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
                        <feGaussianBlur result="effect1_foregroundBlur_5_55" stdDeviation="64" />
                    </filter>

                    <!-- ── Clip path per il reveal del fulmine ────────────────────
               Il rettangolo cresce in altezza (0→500) nella prima fase,
               poi scivola verso il basso (y: 0→500) nella seconda fase,
               creando l'effetto "rivela dall'alto / nascondi scorrendo".
          ──────────────────────────────────────────────────────────────── -->
                    <clipPath id="lightning-loop-reveal">
                        <rect x="0" width="400" y="0" height="0">

                            <!-- height: 0 → 500 → 500 → 500  (reveal) -->
                            <animate attributeName="height" values="0;500;500;500" keyTimes="0;0.4;0.6;1" dur="2.5s"
                                repeatCount="indefinite" calcMode="spline"
                                keySplines="0.42 0 0.58 1; 0 0 1 1; 0 0 1 1" />

                            <!-- y: 0 → 0 → 0 → 500  (slide down to hide) -->
                            <animate attributeName="y" values="0;0;0;500" keyTimes="0;0.4;0.6;1" dur="2.5s"
                                repeatCount="indefinite" calcMode="spline"
                                keySplines="0 0 1 1; 0 0 1 1; 0.42 0 0.58 1" />

                        </rect>
                    </clipPath>
                </defs>

                <!-- ── Gruppo principale ───────────────────────────────────────── -->
                <g id="Loader">

                    <!-- Glow pulsante — opacità 0.2 → 0.6 → 0.2, 2.5s -->
                    <g filter="url(#filter0_f_5_55)" id="Glow">
                        <rect fill="#FDC700" height="241" width="138" x="128" y="128">
                            <animate attributeName="fill-opacity" values="0.2;0.6;0.2" dur="2.5s"
                                repeatCount="indefinite" calcMode="spline" keySplines="0.42 0 0.58 1; 0.42 0 0.58 1" />
                        </rect>
                    </g>

                    <!-- Sfondo: ombra nera + pannello giallo -->
                    <g id="Sfondo">
                        <path [attr.d]="pathOmbra" fill="#000000" id="Ombra" />
                        <path [attr.d]="pathSfondo" fill="#FFDE3B" id="Sfondo_2" />
                    </g>

                    <!-- Fulmine viola — mascherato con clip per il reveal animato -->
                    <path [attr.d]="pathFulmine" fill="#5032B2" id="Fulmine" clip-path="url(#lightning-loop-reveal)" />

                </g>
            </svg>

        </div><!-- /loader-translate-y -->
    </div><!-- /loader-translate-x -->
</div><!-- /loader-rotate -->